// Updated App.jsx
import { useEffect } from 'react';
import { globalAudio } from './utils/globalAudio';
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import PodcastHub from './pages/PodcastHub'
import LearningHub from './pages/LearningHub'
import CourseDetail from './pages/CourseDetail'
import AmbassadorProgram from './pages/AmbassadorProgram'
import Dashboard from './pages/Dashboard'
import Auth from './pages/Auth'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import Pricing from './pages/Pricing'
import Checkout from './pages/Checkout'
import { Navigate } from 'react-router-dom'
import LearningPath from './pages/LearningPath'
import PodcastSeries from './pages/PodcastSeries'
import PageLayout from './components/PageLayout'
import SeriesList from './pages/seriesList'
import ForgotPassword from './components/ForgotPassword'
import LearningPathsList from './pages/LearningPathsList'
import ComingSoonPodcast from './pages/ComingSoonPodcast'
import PaymentTest from './components/PaymentTest'
import ContactSales from './pages/ContactSales'
import AdminNotifications from './components/tabs/AdminNotifications'
import ProtectedRoute from './components/ProtectedRoute'
import { audioPersistence } from './utils/audioPersistence';
import { initAudioPersistence } from './utils/audioPersist';

function App() {
  useEffect(() => {
    // Initialize audio persistence
    initAudioPersistence();
  }, []);

  return (
    <>
      <Routes>
        {/* Public Pages with Header & Footer */}
        <Route path="/" element={
          <PageLayout>
            <Home />
          </PageLayout>
        } />
        <Route path="/podcasts" element={
          <PageLayout>
            <PodcastHub />
          </PageLayout>
        } />
        <Route path="/courses" element={
          <PageLayout>
            <LearningHub />
          </PageLayout>
        } />
        <Route path="/course/:id" element={
          <PageLayout>
            <CourseDetail />
          </PageLayout>
        } />
        <Route path="/ambassador-program" element={
          <PageLayout>
            <AmbassadorProgram />
          </PageLayout>
        } />
        <Route path="/pricing" element={
          <PageLayout>
            <Pricing />
          </PageLayout>
        } />
        <Route path="/checkout" element={
          <PageLayout>
            <Checkout />
          </PageLayout>
        } />
        <Route path="/contact-sales" element={
          <PageLayout>
            <ContactSales />
          </PageLayout>
        } />
        
        {/* Protected Dashboard */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <PageLayout>
              <Dashboard />
            </PageLayout>
          </ProtectedRoute>
        } />
        
        {/* PODCAST SERIES ROUTES */}
        <Route path="/podcast-series" element={
          <PageLayout>
            <SeriesList />
          </PageLayout>
        } />
        <Route path="/podcast-series/:id" element={
          <PageLayout>
            <PodcastSeries />
          </PageLayout>
        } />
        <Route path="/podcast/coming-soon/:id" element={
          <PageLayout>
            <ComingSoonPodcast />
          </PageLayout>
        } />

        {/* LEARNING PATHS */}
        <Route path="/learning-paths" element={
          <PageLayout>
            <LearningPathsList />
          </PageLayout>
        } />
        <Route path="/learning-path/:id" element={
          <PageLayout>
            <LearningPath />
          </PageLayout>
        } />
        
        {/* Auth pages without Header & Footer */}
        <Route path="/auth" element={
          <PageLayout showHeader={false} showFooter={false}>
            <Auth />
          </PageLayout>
        } />
        <Route path="/forgotpassword" element={
          <PageLayout showHeader={false} showFooter={false}>
            <ForgotPassword />
          </PageLayout>
        } />

        {/* Admin Login (no header/footer) */}
        <Route path="/admin/login" element={
          <PageLayout showHeader={false} showFooter={false}>
            <AdminLogin />
          </PageLayout>
        } />
        
        {/* Protected Admin Routes */}
        {/* FIXED: Removed duplicate closing tags and incorrect nesting */}
        <Route path="/admin/dashboard" element={
          <ProtectedRoute adminOnly>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/notifications" element={
          <ProtectedRoute adminOnly>
            <PageLayout>
              <AdminNotifications />
            </PageLayout>
          </ProtectedRoute>
        } />
        
        {/* Admin Redirect */}
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        
        {/* Test routes */}
        <Route path="/test-payments" element={
          <PageLayout>
            <PaymentTest />
          </PageLayout>
        } />
        
        {/* Redirects for old routes */}
        <Route path="/learninghub" element={<Navigate to="/courses" replace />} />
        <Route path="/podcasthub" element={<Navigate to="/podcasts" replace />} />
        
        {/* 404 Page */}
        <Route path="*" element={
          <PageLayout>
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center p-6">
                <div className="text-9xl font-bold text-gray-200 mb-4">404</div>
                <h1 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h1>
                <p className="text-gray-600 mb-8 max-w-md mx-auto">
                  The page you're looking for doesn't exist or has been moved.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a 
                    href="/" 
                    className="px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary/90 transition-colors"
                  >
                    Go Home
                  </a>
                  <a 
                    href="/podcasts" 
                    className="px-6 py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors"
                  >
                    Browse Podcasts
                  </a>
                </div>
              </div>
            </div>
          </PageLayout>
        } />
      </Routes>
    </>
  )
}

export default App